import { render, staticRenderFns } from "./Pandeaming.vue?vue&type=template&id=c50568cc&"
import script from "./Pandeaming.vue?vue&type=script&lang=js&"
export * from "./Pandeaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports